//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { CustomFieldValueInputItem } from './CustomFieldValueInputItem';
import { CustomFieldType } from './Enums';

export class CustomFieldPolicyValueInputItem extends CustomFieldValueInputItem {
    Accepted: boolean = false;
    override readonly FieldType: CustomFieldType = CustomFieldType.Policy;

    constructor(initializer?: Partial<Omit<CustomFieldPolicyValueInputItem, "FieldType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CustomFieldPolicyValueInputItem";
}
